module.exports = __webpack_public_path__ + "static/media/Custodio.04eee815.png";